import React from 'react';
import LGASelect from '../lga-select';
import useGlobalState from '../../hooks/use-global-state';
import { setLGA } from '../../modules/app-duck';
import { colors } from '../../modules/theme';

const LGAContent = () => {
  const { dispatch, state } = useGlobalState();

  return (
    <div
      css={{
        background: colors.darkBlue,
        display: 'flex',
        minHeight: 0,
        flexDirection: 'column',
      }}
    >
      <div
        css={{
          padding: '10px 15px',
        }}
      >
        <LGASelect
          value={state.lga}
          onChange={option =>
            dispatch(setLGA(option ? option.value : undefined))
          }
        />
      </div>
    </div>
  );
};

export default LGAContent;
